import { useId } from "react";
import {
  FormGroup,
  FormSection,
  HelpText,
  Input,
  Label,
  SectionTitle,
} from "./styles";

interface OpenAiFieldsProps {
  apiKey: string;
  setApiKey: (value: string) => void;
  model: string;
  setModel: (value: string) => void;
  maxTokens: string;
  setMaxTokens: (value: string) => void;
}

export function OpenAiFields({
  apiKey,
  setApiKey,
  model,
  setModel,
  maxTokens,
  setMaxTokens,
}: OpenAiFieldsProps) {
  const apiKeyId = useId();
  const modelId = useId();
  const maxTokensId = useId();

  return (
    <FormSection>
      <SectionTitle>OpenAI Configuration</SectionTitle>

      <FormGroup>
        <Label htmlFor={apiKeyId}>API Key *</Label>
        <Input
          id={apiKeyId}
          type="password"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="sk-..."
          required
        />
        <HelpText>Your OpenAI API key</HelpText>
      </FormGroup>

      <FormGroup>
        <Label htmlFor={modelId}>Model</Label>
        <Input
          id={modelId}
          type="text"
          value={model}
          onChange={(e) => setModel(e.target.value)}
          placeholder="gpt-4o"
        />
        <HelpText>Leave empty for default (gpt-4o)</HelpText>
      </FormGroup>

      <FormGroup>
        <Label htmlFor={maxTokensId}>Max Tokens</Label>
        <Input
          id={maxTokensId}
          type="number"
          value={maxTokens}
          onChange={(e) => setMaxTokens(e.target.value)}
          placeholder="4096"
        />
        <HelpText>Leave empty for default (4096)</HelpText>
      </FormGroup>
    </FormSection>
  );
}
